/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AppointmentBookingState from 'DesignSystem/AppointmentBookingState/index'
import Color from './Color/index'
import MissingNotes from './MissingNotes/index'
import Name from './Name/index'
import Profile from './Profile/index'
import React from 'react'
import StateOrAction from './StateOrAction/index'
import Type from './Type/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Appointments/Content/Appointment",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  onMouseEnterName,
  onMouseLeaveName,
  hoveredName
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let appointmentBookingItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking_item',
path: 'isFirst',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsOrange100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.100'
        })
let dtColorsOrange200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  onMouseEnterName,
  onMouseLeaveName,
  hoveredName
  
})
let appointmentBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'state',
})
  return (<React.Fragment
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--pt-1-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-3-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-4-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-6-dUIJ5': isHoveredManual ? dtColorsOrange200 : dtColorsOrange100,'--mt-5-dUIJ5': appointmentBookingItemIsFirstValueData ? "0px" : "4px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<StateOrAction
  viewPath={`${viewPath}/StateOrAction`}
 is_hovered={isHoveredManual}
/>
</div>
<Color
  viewPath={`${viewPath}/Color`}
/>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Profile
  viewPath={`${viewPath}/Profile`}
/>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Appointment.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<AppointmentBookingState
  viewPath={`${viewPath}/AppointmentBookingState`}
 data="appointment_booking.state"
 state={appointmentBookingStateValueData}
/>
<MissingNotes
  viewPath={`${viewPath}/MissingNotes`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:4"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnterName}
 onMouseLeave={onMouseLeaveName}
 className={`views-block ${styles.Horizontal4}`}
>
<Name
  viewPath={`${viewPath}/Name`}
 hovered={hoveredName}
/>
</div>
<div
  data-testid="Appointment.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}